// extracted by mini-css-extract-plugin
module.exports = {"card":"CardAdd_card_1nNfo","image":"CardAdd_image_3-PFQ","title":"CardAdd_title_3_ZDl"};